module.exports = __webpack_public_path__ + "static/media/video-yt.a4d27cef.svg";